export const PAGE_COLORS = {
  Blocks: {
    cl: '#79C600',
    cl1: '#79C600'
  },
  Block: {
    cl: '#79C600',
    cl1: '#79C600'
  },
  Transactions: {
    cl: '#FF9100'
  },
  Transaction: {
    cl: '#FF9100'
  },
  Addresses: {
    cl: '#FF71E1'
  },
  Address: {
    cl: '#FF71E1'
  },
  Tokens: {
    cl: '#08FFD0',
    cl1: '#08FFD0',
    cl2: '#000'
  },
  'Token Account': {
    cl: '#08FFD0',
    cl1: '#08FFD0',
    cl2: '#000'
  },
  'Internal transaction': {
    cl: '#FF9100'
  },
  Event: {
    cl: '#FF9100'
  },
  'Verify contract': {
    cl: '#FF71E1'
  },
  Config: {
    cl: '#08FFD0'
  },
  txPool: {
    cl: '#08FFD0'
  },
  'Account Balance': {
    cl: '#FF71E1'
  }
}
